import React from 'react';
import { Switch, Route, withRouter, HashRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Login from '../login/index';
import Home from '../home/index.js'; // home page for members/Affilates
import Dashboard from '../cpdrecord/index.js';
import CPDGO from '../cpdgo/index.js';
import mycpd from '../mycpd';
import FaceToFace from '../face_to_face_cpd';
import ApprovedCPDProviders from '../approved_cpd_providers';
import Library from '../library';
import ProtectedRoute from '../components/ProtectedRoute';

import AdminDashboad from '../../src/Admin/home'; //  home page for staff
import CpdAdmin from '../../src/Admin/cpdadmin';

import MemberAdmin from '../../src/Admin/memberAdmin';
import AccredAdmin from '../../src/Admin/accredtadmin';
import Host from '../../src/Admin/host';
import UserManagment from '../../src/Admin/usermanagement';
import AdminSettings from '../../src/Admin/adminsettings';
import CpdReport from '../../src/Admin/cpdreport';
import CompliantReport from '../../src/Admin/compliantreport';
import IndividualUserReport from '../../src/Admin/individualuserreport';
import SystemUsageReport from '../../src/Admin/systemusagereport';
import RegisterForm from '../../src/Admin/formregister';
import FormCPD from '../../src/Admin/recordcpd';
import RecordedZeroHour from '../Admin/recordzerohour';
import MyCpdReport from '../Admin/mycpdreport';
import MonthlyView from '../Admin/monthlyview';
import RandomReport from '../Admin/randomreport';
import servicelogin from '../servicelogin/index';
import AffiliateReport from '../Admin/affiliatereport';
import VideoAccess from '../Admin/videoaccess';

class App extends React.Component {
  render() {
    // const currentURL = window.location.href;
    // const currentPath = currentURL.split("/")[4];
    const user = this.props.user.access_token;
    const role = this.props.user.role;

    return (
      <div className={!user ? 'container' : 'container-main main-content'}>
        <HashRouter>
          <Switch>
            <Route
              exact
              path="/servicelogin"
              component={withRouter(servicelogin)}
            />
            <Route exact path="/" component={withRouter(Login)} />
            <Route exact path="/login" component={withRouter(Login)} />
            {role === 'Staff' ? (
              <ProtectedRoute
                exact
                path="/home"
                component={withRouter(AdminDashboad)}
              />
            ) : (
              <ProtectedRoute exact path="/home" component={withRouter(Home)} />
            )}
            <ProtectedRoute
              exact
              path="/cpdrecord"
              component={withRouter(Dashboard)}
            />
            <ProtectedRoute
              exact
              path="/my_cpd_report/:userId/:memberId"
              component={withRouter(MyCpdReport)}
            />

            <ProtectedRoute exact path="/cpdgo" component={withRouter(CPDGO)} />
            <ProtectedRoute
              exact
              path="/mycpd/:workFlowId/:mode?"
              component={withRouter(mycpd)}
            />
            <ProtectedRoute exact path="/mycpd" component={withRouter(mycpd)} />

            <ProtectedRoute
              exact
              path="/cpdclassroom"
              component={withRouter(FaceToFace)}
            />
            <ProtectedRoute
              exact
              path="/CPDACCREDITED"
              component={withRouter(ApprovedCPDProviders)}
            />
            <ProtectedRoute
              exact
              path="/library"
              component={withRouter(Library)}
            />
            <ProtectedRoute
              exact
              path="/cpdadmin"
              component={withRouter(CpdAdmin)}
            />
            <ProtectedRoute
              exact
              path="/memberadmin"
              component={withRouter(MemberAdmin)}
            />
            <ProtectedRoute
              exact
              path="/accredtadmin"
              component={withRouter(AccredAdmin)}
            />
            <ProtectedRoute exact path="/host" component={withRouter(Host)} />
            <ProtectedRoute
              exact
              path="/usermanagment"
              component={withRouter(UserManagment)}
            />
            <ProtectedRoute
              exact
              path="/videoaccess"
              component={withRouter(VideoAccess)}
            />
            <ProtectedRoute
              exact
              path="/adminsetting"
              component={withRouter(AdminSettings)}
            />
            <ProtectedRoute
              exact
              path="/reportadmin"
              component={withRouter(CpdReport)}
            />
            <ProtectedRoute
              exact
              path="/compliantreport/:reportid?"
              component={withRouter(CompliantReport)}
            />
            <ProtectedRoute
              exact
              path="/individualuserreport"
              component={withRouter(IndividualUserReport)}
            />
            <ProtectedRoute
              exact
              path="/systemusagereport"
              component={withRouter(SystemUsageReport)}
            />
            <ProtectedRoute
              exact
              path="/register/:workFlowId?"
              component={withRouter(RegisterForm)}
            />

            <ProtectedRoute
              exact
              path="/recordedzerohour/:recordId?"
              component={withRouter(RecordedZeroHour)}
            />

            <ProtectedRoute
              exact
              path="/myCpdRecord/:workFlowId/:mode?"
              component={withRouter(FormCPD)}
            />
            <ProtectedRoute
              exact
              path="/monthviewcpd"
              component={withRouter(MonthlyView)}
            />

            <ProtectedRoute
              exact
              path="/randomreport"
              component={withRouter(RandomReport)}
            />
            <ProtectedRoute
              exact
              path="/affiliatereport"
              component={withRouter(AffiliateReport)}
            />
          </Switch>
        </HashRouter>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
export default connect(mapStateToProps, null)(withRouter(App));
